import { provide, inject, ref, onMounted, onBeforeUnmount } from 'vue'

export function assignValue (targetRefs, ...sources) {
  const newValues = Object.assign({}, ...sources)

  for (const name in targetRefs) {
    const newValue = newValues[name]
    if (typeof newValues[name] === 'undefined') {
      return
    }
    targetRefs[name].value = newValue
  }
}

export function provideRef (key, value) {
  const valueRef = ref(value)
  provide(key, valueRef)
  return valueRef
}

const websiteUrlKey = Symbol('websiteUrl')

export function setupWebsiteUrl (websiteUrl) {
  return provideRef(websiteUrlKey, websiteUrl)
}

export function getWebsiteUrl () {
  return inject(websiteUrlKey).value
}

export function setupTagMamanger (tagManagerId) {
  let script
  onMounted(function () {
    script = document.createElement('script')
    script.innerHTML = `(function(w, d, s, l, i) {w[l] = w[l] || [];w[l].push({'gtm.start': new Date().getTime(),event: 'gtm.js'});var f = d.getElementsByTagName(s)[0],j = d.createElement(s),dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src='https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);})(window, document, 'script', 'dataLayer', '${tagManagerId}');`
    document.head.appendChild(script)
  })
  onBeforeUnmount(function () {
    script.remove()
  })
}
